import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CategoriesComponent } from './pages/categories/categories.component';
import { NavbarComponent } from './pages/components/navbar/navbar.component';
import { HomepageComponent } from './pages/homepage/homepage.component';
import { FooterComponent } from './pages/components/footer/footer.component';
import { SignupComponent } from './pages/signup/signup.component';
import { LoginComponent } from './pages/login/login.component';
import { GameDetailComponent } from './pages/game-detail/game-detail.component';
import { LeaderboardComponent } from './pages/leaderboard/leaderboard.component';
import { ProfileComponent } from './pages/profile/profile.component';
import {HttpClientModule} from "@angular/common/http";
import { ResetpasswordComponent } from './pages/resetpassword/resetpassword.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { LimitToPipe } from './pipes/limit-to.pipe';
import { VerificationComponent } from './pages/verification/verification.component';
import { GamesComponent } from './pages/games/games.component';
import {NgxPaginationModule} from "ngx-pagination";
import { SecondVerificationComponent } from './pages/second-verification/second-verification.component';
import { TermsConditionsComponent } from './pages/terms-conditions/terms-conditions.component';
import { Error404Component } from './pages/404 page/error404/error404.component';
import { HeroComponent } from './pages/components/hero/hero.component';
import { WhatsNewComponent } from './pages/whats-new/whats-new.component';
import { FeaturedComponent } from './pages/featured/featured.component';
import { ExploreComponent } from './pages/explore/explore.component';
import { HowToSignUpComponent } from './pages/components/how-to-sign-up/how-to-sign-up.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { HeroAboutComponent } from './pages/components/hero-about/hero-about.component';
import { DoMoreGamesComponent } from './pages/components/do-more-games/do-more-games.component';
import { WhatWeOfferComponent } from './pages/components/what-we-offer/what-we-offer.component';
import { WhyChooseComponent } from './pages/components/why-choose/why-choose.component';
import { JoinRevolutionComponent } from './pages/components/join-revolution/join-revolution.component';
import { SupportComponent } from './pages/support/support.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { ContactUsComponent } from './pages/contact-us/contact-us.component';
import { FaqComponent } from './pages/faq/faq.component';
import { NewsPromotionsComponent } from './pages/news-promotions/news-promotions.component';
import { NewsPromotionDetailComponent } from './pages/news-promotion-detail/news-promotion-detail.component';

@NgModule({
  declarations: [
    AppComponent,
    CategoriesComponent,
    NavbarComponent,
    HomepageComponent,
    FooterComponent,
    SignupComponent,
    LoginComponent,
    GameDetailComponent,
    LeaderboardComponent,
    ProfileComponent,
    ResetpasswordComponent,
    LimitToPipe,
    VerificationComponent,
    GamesComponent,
    SecondVerificationComponent,
    TermsConditionsComponent,
    Error404Component,
    HeroComponent,
    WhatsNewComponent,
    FeaturedComponent,
    ExploreComponent,
    HowToSignUpComponent,
    AboutUsComponent,
    HeroAboutComponent,
    DoMoreGamesComponent,
    WhatWeOfferComponent,
    WhyChooseComponent,
    JoinRevolutionComponent,
    SupportComponent,
    PrivacyPolicyComponent,
    ContactUsComponent,
    FaqComponent,
    NewsPromotionsComponent,
    NewsPromotionDetailComponent,

  ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        ReactiveFormsModule,
        NgxPaginationModule,
        FormsModule,
    ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
